import React from 'react';
import PropTypes from 'prop-types';
import {Label} from '../Label';
import {OverlaySlider} from '../OverlaySlider';
import {SliderGroup} from '../SliderGroup';
import {COMPONENT_TYPE} from '@learningblocks/exp-constants/lib/Utilities';

/**
 * SingleSelectOptionComponent:
 *  - To display the content of a SingleSelectOption.
 */
export function SingleSelectOptionItem(props) {
  const renderOverlaySlider = () => (
    <OverlaySlider
      sequence={props.sequence}
      highlight={[props.current.start, props.current.end - props.current.start]}
      highlightClass={props.highlightClass}
      onChange={() => {}}
      disable={true}
    />
  );

  const renderSequenceSliderGroup = () => (
    <SliderGroup
      id={props.id}
      sliders={props.sliders}
      componentID={0}
      changeHighlight={() => {}}
    />
  );

  switch (props.type) {
    case COMPONENT_TYPE.SEQUENCE_SLIDER:
      return renderOverlaySlider();
    case COMPONENT_TYPE.SEQUENCE_SLIDER_GROUP:
      return renderSequenceSliderGroup();
    case COMPONENT_TYPE.LABEL:
      return <Label label={props.text} id={props.id} />;
    default:
      return null;
  }
}

SingleSelectOptionItem.propTypes = {
  /**
   *  The type of component to be displayed in the option
   */
  type: PropTypes.string.isRequired,
  /**
   * The string text to be displayed as label [Plain CSCQ]
   */
  text: PropTypes.string,
  /**
   * Sequence string to be dispalyed [Sequnce-Slider Option]
   */
  sequence: PropTypes.string,
  /**
   * Object containing info on currently selected string [Sequnce-Slider Option]
   */
  current: PropTypes.shape({
    /**
     * Currently selected string
     */
    text: PropTypes.string,
    /**
     * Start-Index of Currently selected string
     */
    start: PropTypes.number,
    /**
     * End-Index of Currently selected string
     */
    end: PropTypes.number,
  }),
  /**
   * String to set the highlighting colour [Sequnce-Slider Option]
   */
  highlightClass: PropTypes.oneOf(['null', 'red', 'green', 'blue']),
};

SingleSelectOptionItem.defaultProps = {
  type: 'LABEL',
};
